import ConstellationViewBg from "/images/discover_communities/constellation_view.png";

export const ConstellationView = () => {
  return (
    <div className="w-full h-full mt-6 rounded-lg overflow-hidden">
      <img
        src={ConstellationViewBg}
        alt="Constellation View Feature"
        className="w-full h-full object-cover"
      />
    </div>
  );
};
